import { useEffect, useState } from "react";
import { ArrowRight, CheckCircle2, XCircle } from "lucide-react";
import { api } from "../../lib/api";
import { Reveal, SectionHeading } from "../Reveal";

export function SuccessStories() {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    api.get("/content/case-studies").then((r) => setStories(r.data || [])).catch(() => {});
  }, []);

  return (
    <section id="success-stories" data-testid="success-stories-section" className="relative overflow-hidden bg-forest-deep py-20 lg:py-28">
      <div className="bg-noise pointer-events-none absolute inset-0" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          dark
          chapter={["05", "Proof in Outcomes"]}
          title={
            <>
              Before. After.{" "}
              <em className="font-editorial font-medium italic text-gold">Decided.</em>
            </>
          }
          subtitle="Real clients, real turning points. Every story below started with one free strategy call."
        />

        <div className="mt-14 grid gap-6 lg:grid-cols-3" data-testid="case-studies-grid">
          {stories.map((story, i) => (
            <Reveal key={story.id || story.title} delay={i * 0.1}>
              <article
                data-testid={`case-study-${i}`}
                className="group flex h-full flex-col rounded-3xl border border-emerald-100/10 bg-[#0F2B22] p-7 transition-[transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-gold/40"
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-emerald-100/45">
                    {story.category}
                  </span>
                  <span className="rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-forest-deep">
                    {story.outcome}
                  </span>
                </div>
                <h3 className="mt-4 font-editorial text-xl italic leading-snug text-bone">{story.title}</h3>

                <div className="mt-6 space-y-3">
                  <div className="rounded-2xl border border-emerald-100/10 bg-forest-ink/60 p-4">
                    <p className="flex items-center gap-2 font-mono text-[9px] uppercase tracking-[0.25em] text-red-300/70">
                      <XCircle className="h-3.5 w-3.5" /> Before
                    </p>
                    <p className="mt-2 text-sm leading-relaxed text-emerald-100/55">{story.before}</p>
                  </div>
                  <div className="flex justify-center">
                    <ArrowRight className="h-4 w-4 rotate-90 text-gold" />
                  </div>
                  <div className="rounded-2xl border border-gold/25 bg-gold/5 p-4">
                    <p className="flex items-center gap-2 font-mono text-[9px] uppercase tracking-[0.25em] text-gold">
                      <CheckCircle2 className="h-3.5 w-3.5" /> After
                    </p>
                    <p className="mt-2 text-sm font-medium leading-relaxed text-bone">{story.after}</p>
                  </div>
                </div>

                <blockquote className="mt-auto pt-6 text-sm italic leading-relaxed text-emerald-100/60">
                  “{story.quote}”
                </blockquote>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
